import MyOceanityNav from "./components/MyOceanityNav";
import React from "react";
import { Table, Button, ButtonGroup, Card, CardDeck, Image, Carousel, Container, Row, Col } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Icons from '@fortawesome/free-solid-svg-icons';
import christraits from "./images/chris-ocean-traits.png";
import chriscomparisons from "./images/chris-traits-comparisons.png";
import chriscircle from "./images/chris-circle-picture.png"
import emotionscollage from "./images/emotions-collage.jpg";
import { useAuth0 } from "@auth0/auth0-react";

export default function Home() {
    const { isAuthenticated, loginWithRedirect, logout, user, isLoading } = useAuth0()

    const iconList = Object
	.keys(Icons)
	.filter(key => key !== "fas" && key !== "prefix" )
	.map(icon => Icons[icon])
  
    library.add(...iconList)
      
    return (
        <div>
    {/*
            <MyOceanityNav fixed="top" />
    */}
            <div className="overlay">
                
                <section className="title">
        
                    <div className="separator" />
                    
                    <h1 className="mb-3">Realize your potential by growing your emotional intelligence</h1>
                    <h2>Nurture your relationships & live a meaningful life</h2>
                    <a href="/what-we-do" className="title-link">Learn more about what we do</a>

                    <div className="separator" />

                </section>

                <section className="white-section">
                    
                    <div className="separator" />
                    <div className="separator" />

                    <h2>Explore 3 powerful tools</h2>
                    
                    <div className="separator" />
                    <div className="separator" />


                    <CardDeck>
                        
                        <Card className="mb-4 mycardwrapper">
                            <Card.Body className="text-center mycard">
                                <a href="/user/premium/my-assessments"> <FontAwesomeIcon icon="clipboard-check" size="6x" className="card-icon" /> </a>
                                <Card.Title><a href="/user/premium/my-assessments" className="cardlink stretched-link"><h5 className="cardtitle card-btn">Assess your personality traits</h5></a></Card.Title>
                                <Card.Text className="cardtext">
                                    <p>Who are you? What makes you tick?</p>
                                    <p>How are <a href="/ocean-personality-traits" className="intlink">your personality traits</a> affecting others? How can you improve?</p>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    
                        <Card className="mb-4 mycardwrapper">
                            <Card.Body className="text-center mycard">
                                    <a href="/user/premium/send-invite"> <FontAwesomeIcon icon="users" size="6x" className="card-icon" /> </a>
                                    <Card.Title><a href="/user/premium/send-invite" className="cardlink stretched-link"><h5 className="cardtitle card-btn">Invite and compare to others</h5></a></Card.Title>
                                    <Card.Text className="cardtext">
                                        <p>How similar and different are you?</p>
                                        <p>How can you better understand and interact with each other?</p>
                                    </Card.Text>
                            </Card.Body>
                        </Card>
                        
                        <Card className="mb-4 mycardwrapper">
                            <Card.Body className="text-center mycard">
                                <a href="/ei-course"> <FontAwesomeIcon icon="chalkboard-teacher" size="6x" className="card-icon" /> </a>
                                <Card.Title><a href="/ei-course" className="cardlink stretched-link"><h5 className="cardtitle card-btn">Go to the online course</h5></a></Card.Title>
                                <Card.Text className="cardtext">
                                    <p>Join our learning & development program</p>
                                    <p>Study at your own pace, anytime, anywhere, without any distractions</p>
                                </Card.Text>
                            </Card.Body>
                        </Card>

                    </CardDeck>

                    <Row>
                    <Card className="mb-4 mycardwrapper">
                        <Card.Body className="text-center mycard">
                            <Card.Title><h3>1. Discover your personality traits</h3></Card.Title>
                            <Card.Img src={christraits} alt="Chris' personality traits" variant="top" />
                            <Card.Text className="cardtext" >
                                <div className="separator" />

                                <p className="text-center"><i>Chris' personality traits</i></p>
                                
                                <div  className="quote">
                                <p><i>"Personality is every individual's signature trait. There will never be anyone like you, therefore hold on to what makes you so special as a person, a character, and a human being."</i></p>
                                <p><b>Unknown author</b></p>
                                </div>
                                
                                <p>Your <a href="/ocean-personality-traits" className="intlink">personality traits</a> influence your preferences, motivations, and behaviors, which determine how trustable, likable and reliable others perceive you to be.</p>
                                
                                <div className="notabene">
                                <p className="text-center"> When you start to understand the world within, then the world around you starts to make more sense.</p>
                                </div>
                                
                                <div className="input-group">
                                    <div className="input-group-append content-btn-box">
                                        <a href="/user/premium/my-assessments" className="content-btn">Discover your traits</a>
                                    </div>
                                </div>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                    </Row>

                    <Row>
                        <Card className="mb-4 mycardwrapper">
                            <Card.Body className="text-center mycard">
                                <Card.Title><h3>2. Compare your personality traits to other people's</h3></Card.Title>
                                <Card.Img src={chriscomparisons} alt="Comparing Chris' personality traits to Feffef's" variant="top" />
                                <Card.Text className="cardtext" >
                                    <div className="separator" />
                                    <p className="text-center"><i>Comparing Chris' personality traits to Feffef's</i></p>
                                    
                                    <div className="quote">
                                    <p><i>"Strength lies in differences, not in similarities."</i></p>
                                    <p><b>Stephen Covey</b></p>
                                    </div>

                                    <div className="quote">
                                    <p><i>"It is not our differences that divide us. It is our inability to recognize, accept, and celebrate those differences."</i></p>
                                    <p><b>Audre Lorde</b></p>
                                    </div>
                                    
                                    <p>One of the best ways to grow your emotional intelligence and to build lasting, mutually beneficial relationships, is to understand how your personality traits differ from those of people you know, and how you can become stronger together because of your diffences. </p>
                                    
                                    <p className="text-center"><b>Please note that you first need to take your personal assessment before you can compare it to other people's.</b></p>
                                    
                                    <div className="input-group">
                                        <div className="input-group-append content-btn-box">
                                            <a href="/user/premium/send-invite" className="content-btn">Invite others and compare your traits</a>
                                        </div>
                                    </div>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Row>

                    <Row>
                        <Card className="mb-4 mycardwrapper">
                            <Card.Body className="text-center mycard">
                                <Card.Title><h3>3. Grow your emotional intelligence with our online course</h3></Card.Title>
                                
                                <div className="myimg align-center">
                                <Card.Img src={emotionscollage} alt="We all experience a rich palette of emotions" variant="top" />
                                </div>

                                <Card.Text className="cardtext" >
                                    <div className="separator" />
                                    <p className="text-center img-caption"><i>We all experience a rich palette of emotions</i></p>
                                    <p className="text-center img-caption"><i>Photo by <a href="https://www.pexels.com/@olly?utm_content=attributionCopyText&utm_medium=referral&utm_source=pexels" className="intlink">Andrea Piacquadio</a> from <a href="https://www.pexels.com/photo/collage-photo-of-woman-3812743/?utm_content=attributionCopyText&utm_medium=referral&utm_source=pexels" className="intlink">Pexels</a></i></p>
                                    
                                    <div  className="quote">
                                    <p><i>"People will forget what you say. They will forget what you do. <b>But they will never forget how you made them feel</b>."</i></p>
                                    <p><b>Maya Angelou</b></p>
                                    </div>

                                    <p>Emotional intelligence makes people more likable and trustworthy. It makes life at home and at work more enjoyable and was included in the top 5 skills you need to learn, according to <a href="https://learning.linkedin.com/blog/top-skills/the-skills-companies-need-most-in-2020and-how-to-learn-them" className="intlink" >LinkedIn Learning</a>. </p>

                                    <div className="input-group">
                                        <div className="input-group-append content-btn-box">
                                            <a href="/ei-course" className="content-btn">Discover the course</a>
                                        </div>
                                    </div>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Row>

                    <div className="separator" />

                </section>

                <section className="blue-section" >

                    <div className="separator" />

                    <h2>Trusted by over 50 people already</h2>

                    <div className="home-carousel">
        
                        <Carousel interval={18000} >

                            <Carousel.Item style={{'height':"500px"}} >
                                <Carousel.Caption className="carousel-caption">
                                    <p><i>"We invited Chris for a teambuilding workshop in December 2019 to learn about emotional intelligence and how it could help us better understand and work with each other.</i></p>
                                    <p><i>I quickly noticed an encouraging change in how my people interacted with each other and with others outside the team. It also helps my with how I lead and motivate each of them day after day.</i></p>
                                    <p><i>We keep referring to what Chris taught us about what makes each of us tick, which helps us to engage in productive conversations rather than destructive conflicts.</i></p>
                                    <p><i>I appreciate the new perspectives Chris taught us and wholeheartedly recommend him to anyone seeking to grow their emotional intelligence and build lasting, mutually beneficial relationships!"</i></p>
                                    <h4>Andreas Flütsch | Team leader, Johnson & Johnson</h4>
                                </Carousel.Caption>
                            </Carousel.Item>
                                
                            <Carousel.Item style={{'height':"500px"}} >
                                <Carousel.Caption>
                                    <p><i>"We invited Chris to speak at different events and participants were always delighted. He has a way to connect and engage with his audience, which makes the experience even more enriching.</i></p>
                                    <p><i>We appreciated how he clearly and simply guided people to consider new perspectives to improve their lives and careers.</i></p>
                                    <p><i>Anyone looking for a caring and captivating speaker should definitely contact Chris!"</i></p>
                                    <h4>Claude Duc | President, IIBA Geneva</h4>
                                </Carousel.Caption>
                            </Carousel.Item>

                        </Carousel>
        
                    </div>
                    
                    <div className="separator" />

                </section>

                <section className="white-section" >

                    <div className="separator" />
                    <div className="separator" />

                    <h2>Join in 3 simple steps</h2>

                    <div className="separator" />
                    <div className="separator" />

                    <CardDeck>

                        <Card className="mb-4 mycardwrapper">
                            <Card.Body className="text-center mycard">
                                <FontAwesomeIcon icon="user-plus" size="6x" className="card-icon" />
                                <Card.Title><Button className="card-btn-signup" onClick={() => loginWithRedirect()}><p>Create an account</p></Button></Card.Title>
                                <Card.Text className="cardtext">
                                    <p>Your personal and comparison profiles will be saved in your account</p>
                                    <p>You can take as many as you want!</p>
                                </Card.Text>
                            </Card.Body>
                        </Card>

                        <Card className="mb-4 mycardwrapper">
                            <Card.Body className="text-center mycard">
                                <FontAwesomeIcon icon="shopping-cart" size="6x" className="card-icon" />
                                <Card.Title><h5 className="cardtitle card-btn-disabled" >Activate your account</h5></Card.Title>
                                <Card.Text className="cardtext">
                                    <p>You will be redirected to our payment provider during your first assessment</p>
                                    <p><b>USD 20 for lifetime access</b></p>
                                </Card.Text>
                            </Card.Body>
                        </Card>

                        <Card className="mb-4 mycardwrapper">
                            <Card.Body className="text-center mycard">
                                <FontAwesomeIcon icon="thumbs-up" size="6x" className="card-icon" />
                                <Card.Title><h5 className="cardtitle card-btn-disabled">That's it!</h5></Card.Title>
                                <Card.Text className="cardtext">
                                    <p>Enjoy the full MyOceanity experience! Learn, grow, and realize your potential</p>
                                    <div className="white-text"><p> Hello</p></div>
                                </Card.Text>
                            </Card.Body>
                        </Card>

                    </CardDeck>
                    
                    <div className="separator" />

                </section>

                <section className="blue-section" >
                    
                    <div className="separator" />
                    <h2>Get to know us</h2>

                    <div className="two-columns">
                        <div className="chris-img">
                            <a href="/who-we-are" className="chris-img-a">
                            <Image src={chriscircle} alt="Chris Picture Circle"  />
                            </a>
                        </div>
                        
                        <p>Chris dreamed of a world where people could thrive and take care of each other by growing their emotional intelligence, and Dan made this dream become a reality.
                        
                        <div className="separator" />
                        
                        <a href="/who-we-are" className="intlink">Learn more</a> about who we are and what drives us</p>
                        
                        <div className="separator" />
            
                    </div>

                </section>


            </div>            

        </div>
    )
}